import styled, { css } from 'styled-components';
import { Modal } from '../../theme';
import { rem } from '../../utils/index';
import { PRICING_MODAL_PRESETS } from './Modal.presets';
export const ModalSize = {
    Medium: Modal.Size.Medium,
};
export const getModalSize = ({ size = 'Medium' }) => {
    const width = rem(ModalSize[size] || ModalSize['Medium']);
    return css `
    width: ${width};
    max-width: 90%;
  `;
};
/**
 * @TODO
 * This is a temporary solution to fix the pricing modal responsiveness
 * because we are using embed Stripe.
 */
const pricingModalCSS = css `
  min-height: ${PRICING_MODAL_PRESETS.minHeight};
  max-height: ${PRICING_MODAL_PRESETS.maxHeight};
  width: ${PRICING_MODAL_PRESETS.width};
  max-width: ${PRICING_MODAL_PRESETS.maxWidth};
  overflow-x: hidden;
  overflow-y: auto;
  bottom: ${PRICING_MODAL_PRESETS.bottom};
  transform: ${PRICING_MODAL_PRESETS.transform};
  position: absolute;
  top: unset;
  left: ${PRICING_MODAL_PRESETS.left};

  background-color: ${({ theme }) => theme.Color.NeutralsFixed.Paper};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;
export const StyledWrapper = styled.div `
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Modal};
  background: ${({ theme }) => theme.Color.Overlay.Light};
`;
export const StyledContent = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Large)};
  background: ${({ theme }) => theme.Components.Panel.Background};
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
  padding: ${({ theme }) => rem(theme.Spacing.Size.MediumLarge)};
  gap: ${({ theme }) => rem(theme.Spacing.Size.Medium)};
  box-shadow: 0 0 8px ${({ theme }) => theme.Color.Overlay.Light};
  ${({ size }) => getModalSize({ size })};
  ${({ isPricingModal, isMobile }) => !isMobile && isPricingModal ? pricingModalCSS : ''};
`;
//# sourceMappingURL=Modal.style.js.map